<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span
          class="nav-right"
          @click="$router.push({ path: '/WithdrawRecord' })"
          >{{ $t('withdraw.with_record') }}</span
        >
      </template>
    </van-nav-bar>
    <div class="main">
      <div style="margin: 0px auto 10px; width: 100%; background-color: #fff">
        <div
          class="balance"
          style="margin: 20px auto; width: 100%; text-align: center"
        >
          <p>{{ $t('my.balance') }}</p>
          <span class="number" style="font-size: 24px; font-weight: 600">{{
            this.userInfo.money
          }}</span>
        </div>
        <van-tabs
          v-model="active"
          style="background-color: transparent !important"
        >
          <van-tab title="銀行卡" name="bank"></van-tab>
          <van-tab title="現金" name="cash"></van-tab>
        </van-tabs>
      </div>
      <div
        style="
          margin: 10px;
          padding: 10px 15px;
          background-color: #fff;
          border-radius: 15px;
        "
      >
        <div style="position: relative; padding-top: 30px" v-if="active=='bank'">
          <div
            style="
              position: absolute;
              top: 0px;
              right: 0px;
              padding: 3px 6px;
              border-radius: 8px;
              background-color: #000;
              color: #fff;
            "
            @click="
              $router.push({
                path: '/Setbank'
              })
            "
          >
            {{ $t('setting.bind_bank_info') }}
          </div>
          <van-cell :title="$t('setting.bank_info')">
            <template #right-icon>
              <van-icon
                name="arrow"
                size="18px"
                style="margin-top: 12px"
                @click="showBank = true"
              />
            </template>
            <template>
              <div class="van-ellipsis">
                {{ bkitem ? bkitem.bankinfo : '未選擇' }}
              </div>
            </template>
            <template #label>
              <div class="van-ellipsis" style="font-size: 16px !important;color: #000;">
                {{ bkitem ? bkitem.bankid : '' }}
              </div>
            </template>
          </van-cell>
        </div>
        <div class="withdrawMoney">
          <span
            >{{ $t('withdraw.with_money') }} ({{
              $t('reservation.unit')
            }})</span
          >
          <div class="money">
            <div class="moneyNumber">
              <van-field v-model="withdraw_money" type="number" style="border-bottom: 1px solid #c1c1c1;"></van-field>
            </div>
            <span class="all" @click="allMoeny()">{{ $t('index.all') }}</span>
          </div>
          <div class="information">
            <div class="description" style="display: none">
              <van-popover v-model="showPopover" trigger="click">
                <div class="popover-body" style="padding: 10px">
                  <p>
                    1.{{ $t('withdraw.single_limit') }}{{ $t('withdraw.low')
                    }}{{ this.withdrawRole.min }}{{ $t('withdraw.heigh')
                    }}{{ this.withdrawRole.max }}{{ $t('reservation.unit') }}
                  </p>
                  <p>
                    2.{{ $t('withdraw.with_num') }}{{ this.withdrawRole.num
                    }}{{ $t('withdraw.number') }}
                  </p>
                  <p>3.{{ $t('withdraw.with_tip') }}</p>
                </div>
                <template #reference @click="withdrawInfo()">
                  <van-icon name="info-o" />
                  {{ $t('withdraw.limit_desc') }}
                </template>
              </van-popover>
            </div>
          </div>
        </div>
        <div style="margin: 10px auto;text-align: center;">
        <van-button class="withdraw_btn" type="default" @click="doWithdraw()" >
          {{ $t('withdraw.immediately_withdraw') }}</van-button
        >
        </div>
      </div>
    </div>
    <van-popup
      v-model="showBank"
      round
      position="bottom"
      :style="{ height: '35%' }"
    >
      <van-picker
        show-toolbar
        value-key="bankid"
        :columns="userbank"
        @confirm="onConfirm"
        @cancel="showBank = false"
        :confirm-button-text="$t('setting.ok')"
        :cancel-button-text="$t('setting.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tab, Tabs } from 'vant'

Vue.use(Tab)
Vue.use(Tabs)
export default {
  data () {
    return {
      showPopover: false,
      withdraw_money: '',
      userInfo: {},
      userbank: [],
      withdrawRole: {},
      active: 'bank',
      bkid: null,
      bkitem: null,
      showBank: false
    }
  },
  methods: {
    onConfirm (item) {
      this.bkitem = item
      this.showBank = false
    },
    getUserBank () {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        this.userbank = res.data
      })
    },
    back () {
      return window.history.back()
    },
    getUserInfo () {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          this.name = res.data.name
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserWithdrawRole () {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    allMoeny () {
      this.withdraw_money = this.userInfo.money
    },
    doWithdraw () {
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t('setting.correct_money'))
        return false
      } else {
        this.$http({
          method: 'post',
          data: {
            money: this.withdraw_money,
            type: this.active,
            bk_id: this.bkitem.id
          },
          url: 'user_set_withdraw'
        }).then(res => {
          if (res.code === 200) {
            location.reload()
            this.$toast(res.msg)
            this.getUserInfo()
            this.getUserWithdrawRole()
          } else if (res.code === 401) {
            this.$toast(res.msg)
          }
        })
      }
    },
    withdrawInfo () {
      this.showPopover = true
    }
  },
  created () {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserBank()
      this.getUserInfo()
      this.getUserWithdrawRole()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney {
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber {
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all {
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0 !important;
}
.container .main .withdrawMoney .information {
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number {
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}
</style>
